import Lottie from "lottie-react";
import { H2, TextSm } from "components/atoms/text";
import logo from "assets/images/project/logo.png";
import loading from "assets/json/loading.json";

interface Props {
  isLoading: boolean;
}

// ai 검색 로딩 중
const Searching = ({ isLoading }: Props) => {
  return (
    <div className="h-full flex flex-col">
      <H2 className="mt-10 px-5 flex-none">Searching</H2>
      <div className="flex-1 flex flex-col justify-center items-center">
        {isLoading ? (
          <Lottie animationData={loading} style={{ width: 140, height: 140 }} />
        ) : (
          <>
            {" "}
            <img src={logo} alt="" />
            <TextSm className="text-black-40% mt-4">
              검색할 영역을 마우스로 드래그 해주세요
            </TextSm>
          </>
        )}
      </div>
    </div>
  );
};

export default Searching;
